import { Amplify } from 'aws-amplify'

export const USER_POOL_ID_STORAGE_KEY = 'cognito:userPoolId'
export const USER_POOL_CLIENT_ID_STORAGE_KEY = 'cognito:userPoolClientId'

export default function (config) {
	let poolId = config.VUE_APP_AWS_USER_POOL_ID
	let clientId = config.VUE_APP_AWS_USER_POOL_APP_CLIENT_ID
	try {
		const storedPoolId = localStorage.getItem(USER_POOL_ID_STORAGE_KEY)
		if (storedPoolId) poolId = storedPoolId
		const storedClientId = localStorage.getItem(USER_POOL_CLIENT_ID_STORAGE_KEY)
		if (storedClientId) clientId = storedClientId
	} catch {}
	Amplify.configure({
		Auth: {
			Cognito: {
				userPoolId: poolId,
				userPoolClientId: clientId
			}
		}
	})
}
